import SecurityIcon from "@mui/icons-material/Security";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Card, CardContent } from "@mui/material";

export const ForbiddenPage = () => {
  return (
    <div
      className="vh-100 d-flex align-items-center justify-content-center position-relative p-4"
      style={{
        background: "linear-gradient(135deg, #f8f9fa, rgba(255,0,0,0.05), #f8f9fa)",
        overflow: "hidden",
      }}
    >
      {/* Floating Background Blobs */}
      <div className="position-absolute w-100 h-100 top-0 start-0 overflow-hidden">
        <div
          className="position-absolute rounded-circle"
          style={{
            top: "30%",
            left: "25%",
            width: "22rem",
            height: "22rem",
            background: "rgba(255, 0, 0, 0.15)",
            filter: "blur(60px)",
            animation: "pulse 6s infinite",
          }}
        />
        <div
          className="position-absolute rounded-circle"
          style={{
            bottom: "25%",
            right: "30%",
            width: "20rem",
            height: "20rem",
            background: "rgba(255, 0, 0, 0.10)",
            filter: "blur(60px)",
            animation: "pulse 8s infinite",
            animationDelay: "1.5s",
          }}
        />
      </div>

      {/* Main Content */}
      <div
        className="position-relative z-3 w-100"
        style={{ maxWidth: "650px" }}
      >
        <div className="text-center">
          {/* Icon */}
          <div className="d-flex justify-content-center mb-4">
            <div className="position-relative">
              <div
                className="position-absolute rounded-circle"
                style={{
                  inset: 0,
                  background: "rgba(255, 0, 0, 0.20)",
                  filter: "blur(40px)",
                  animation: "pulse 2s infinite",
                }}
              />
              <div
                className="position-relative p-4 rounded-circle border"
                style={{
                  background: "rgba(255, 0, 0, 0.05)",
                  borderColor: "rgba(255, 0, 0, 0.2)",
                  backdropFilter: "blur(6px)",
                }}
              >
                <SecurityIcon style={{ fontSize: "68px", color: "#dc3545", animation: "scaleIn 0.4s ease-out" }} />
              </div>
            </div>
          </div>

          {/* Title */}
          <h1
            className="fw-bold mb-2"
            style={{ fontSize: "2.5rem", color: "#212529" }}
          >
            Access Forbidden
          </h1>

          <div className="d-flex justify-content-center align-items-center gap-2 text-secondary mb-4">
            <WarningAmberIcon style={{ fontSize: "20px", color: "#dc3545", animation: "pulse 1.6s infinite" }} />
            <span>Error Code: 403</span>
          </div>

          {/* Explanation Card */}
          <Card
            className="shadow-sm border-0"
            style={{ background: "rgba(255,255,255,0.65)", backdropFilter: "blur(6px)" }}
          >
            <CardContent className="p-4">
              <p
                className="mb-0 text-center"
                style={{ fontSize: "1rem", color: "#333" }}
              >
                You don’t have permission to view this page. This restriction helps maintain proper access control and workspace security. If you believe this is incorrect, please contact your
                administrator.
              </p>
            </CardContent>
          </Card>

          {/* Notice Box */}
          <div
            className="mt-4 p-3 rounded-3 border"
            style={{
              background: "rgba(255, 0, 0, 0.05)",
              borderColor: "rgba(255, 0, 0, 0.2)",
            }}
          >
            <p
              className="text-center m-0"
              style={{ fontSize: "0.9rem", color: "#444" }}
            >
              <span
                className="fw-semibold"
                style={{ color: "#dc3545" }}
              >
                Security Notice:
              </span>{" "}
              Your access request has been denied due to insufficient permissions.
            </p>
          </div>

          {/* Back Button */}
          <button
            onClick={() => window.history.back()}
            className="btn btn-primary mt-4 px-4 py-2 shadow-sm"
          >
            Go Back
          </button>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: .5; transform: scale(1); }
          50% { opacity: .9; transform: scale(1.12); }
        }

        @keyframes scaleIn {
          0% { transform: scale(.7); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};
